export const materialIconsPath = '@uswds/uswds/dist/img/material-icons';

/*
  Because of the compiled asset size of the ver-uds-uswds-react.js file, 
  we are whitelisting the material-icons in the glob command below rather 
  than including all of them like we were before previously.
*/

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export const allMaterialIconsGlob: Record<
  string,
  { default: string }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
> = import.meta.glob(
  '../../../../node_modules/@uswds/uswds/dist/img/material-icons/{grading,subject,open_in_full}.svg',

  { eager: true },
);

const allMaterialIcons: string[] = Object.entries(allMaterialIconsGlob).map(([, imageModule]) => {
  return imageModule.default;
});

export type MaterialIcons = typeof allMaterialIcons[number];

export const getMaterialIconSrc = (iconName: MaterialIcons): string | null => {
  const materialIcon = Object.keys(allMaterialIconsGlob).find((path) => {
    const iconPathParts = path.split('/');
    const fileName = iconPathParts[iconPathParts.length - 1];
    return fileName === `${iconName}.svg`;
  });

  if (!materialIcon) {
    return null;
  }

  return allMaterialIconsGlob[materialIcon]?.default;
};

export default allMaterialIcons;
